import { useState } from 'react'
import { downloadFile } from '../../../utils/tools'
import axios from 'axios'

const useExportReport = (uuid) => {
    const [ isLoading, setIsLoading ] = useState(false)

    const handleExportToPDF = async () => {
        setIsLoading(true)
        const request = await axios.get(`/reports/downloadPdf?uuid=${uuid}`)
        if (request.status===200) {
            const blob = await request.blob()
            const file = window.URL.createObjectURL(blob)
            downloadFile(file, `fundamentaledge_reports.zip`)
        }
        setIsLoading(false)
    }

    return {
        handleExportToPDF,
        isLoading
    }
}

export default useExportReport